type AppEnv = {
    apiBaseUrl: string;
};

const isProductionBuild = process.env.NODE_ENV === "production";

// Read a build-time env var. The previous version of this function treated
// "" the same as undefined, which silently fell back to localhost when
// .env.production set the variable to an empty string. Now empty string
// is treated as a *deliberate* choice (used to make API calls relative,
// so Firebase Hosting rewrites send them to Cloud Run).
const readApiBaseUrl = (): string => {
    const value = process.env.REACT_APP_API_BASE_URL;
    if (typeof value === "string") return value;
    if (isProductionBuild) {
        throw new Error(
            'REACT_APP_API_BASE_URL is not defined in this production build. ' +
                'Set it explicitly (use "" for same-origin requests through Firebase rewrites) ' +
                'in frontend/.env.production or via the build environment.',
        );
    }
    return "http://localhost:3000";
};

export const envConfig: AppEnv = {
    apiBaseUrl: readApiBaseUrl(),
};
